import React from "react";
import { BookOpen } from "lucide-react";

export default function TopCard({ title, subtitle }) {
  return (
    <div className="flex items-center justify-between bg-[var(--background)] rounded-2xl border-2 border-[var(--hover)] p-4 m-4 shadow mb-4">
      <div className="flex items-center gap-3">
        <BookOpen className="text-[var(--primary)]" size={24} />
        <div>
          <h1 className="text-[var(--primary)] text-lg font-semibold">{title}</h1>
          <p className="text-[var(--subtext)] text-sm">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
